import { ThemeProvider, createTheme } from "@mui/material/styles";
import { themeOptions } from "./theme/theme";
import CssBaseline from "@mui/material/CssBaseline";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/common/layout/layout";
import Home from "./components/home/home";
import NoMatch from "./components/no-match/no-match";
import Gallery from "./components/gallery/gallery";
import Info from "./components/info/info";
import WristbandCollection from "./components/festival-hub/festival-hub";
import Food from "./components/food/food";
import Film from "./components/film/film";
import LineUp from "./components/line-up/line-up";
import Accessability from "./components/accessibility/accessibility";
import PrivacyPolicy from "./components/privacy-policy/privacy-policy";

import "./App.css";

import "./fonts/ivy-presto-headline-light.otf";
import PsychPub from "./components/psych-pub/psych-pub";
import HeadsTalking from "./components/heads-talking/heads-talking";
import StageTimes from "./components/stage-times/stage-times";
import FinalInfo from "./components/final-info/final-info";
import LayoutLanding from "./components/common/layout/layout-landing";
import Landing from "./components/landing/landing";

function App() {
  const theme = createTheme(themeOptions);
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <CssBaseline />
        <Routes>
          <Route path="/" element={<LayoutLanding />}>
            <Route index element={<Landing />} />
          </Route>
          <Route path="/2026" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="important-final-info" element={<FinalInfo />} />
            <Route path="line-up" element={<LineUp />} />
            <Route path="info" element={<Info />} />
            <Route path="stage-times" element={<StageTimes />} />
            <Route path="food" element={<Food />} />
            <Route path="film" element={<Film />} />
            <Route path="heads-talking" element={<HeadsTalking />} />
            <Route
              path="wristband-collection"
              element={<WristbandCollection />}
            />
            <Route path="psych-pub" element={<PsychPub />} />
            <Route path="accessibility" element={<Accessability />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NoMatch />} />
          </Route>
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
